import {useState} from 'react'
import {css} from '@emotion/react'
import MonacoEditor from '@monaco-editor/react'
import {Collapse} from '@/components/Collapse'
import {MarkdownViewer} from './MarkdownViewer.jsx'

const cssMarkdownEditor = css({
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    overflow: 'hidden',

    '&>section': {
        overflow: 'hidden',
    },
})

const cssMarkdownEditorNoPreview = css({
    gridTemplateColumns: '1fr auto',
})

const cssMarkdownViewer = css({
    padding: '0 16px',
})

export const MarkdownEditor = ({className, style, options = {}, ...props}) => {
    const [isViewerExpanded, setIsViewerExpanded] = useState(true)

    const _options = {
        minimap: {enabled: false, ...options.minimap},
        ...options,
    }

    return (
        <div
            className={className}
            style={style}
            css={[cssMarkdownEditor, ! isViewerExpanded && cssMarkdownEditorNoPreview]}
        >
            <MonacoEditor
                language="markdown"
                options={_options}
                {...props}
            />

            <Collapse
                isExpanded={isViewerExpanded}
                position="left"
                onChange={setIsViewerExpanded}
            >
                <MarkdownViewer css={cssMarkdownViewer}>
                    {props.value}
                </MarkdownViewer>
            </Collapse>
        </div>
    )
}
